module.exports = __webpack_public_path__ + "static/img/guide_point.d542c474.png";